<template>
    <div id="addMediaPropertyModal">
        <div class="modal" @click.self="hideModal">
            <div class="modalForm">
                <h2 class="modalTitle">Add Audio</h2>
                <div class="searchContainer">
                    <div class="formRow"><span class="inputTitle">Audio Action Type</span>
                        <select v-model="selectedAudioType">
                            <option value="1">Play on Load</option>
                            <option valie="2">Play on Leave</option>
                        </select>
                    </div>
                    <div class="formRow"><span class="inputTitle">Search Name: </span><input type="text" v-model="searchText" /></div>
                    <div class="formRow" v-if="mediaTypes">
                        <span class="inputTitle">Media Type: </span>
                        <select v-if="mediaTypes" v-model="selectedMediaType" >
                            <option value="">All</option>
                            <option v-for="mt in mediaTypes" :key="mt.value" :value="mt.internalName">{{ mt.displayName }}</option>
                        </select>
                    </div>
                </div>
                <hr />
                <ListingTable v-if="mediaProperties" :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
                    :key="componentKey" :intitializationParameters="{ sortBy: 'id', sortDirection: 'desc', pageSize: '10'}" />
                <div class="formRow">
                    <button @click="hideModal" class="cancelButton">Cancel</button>
                </div>
            </div>            
        </div>
    </div>
</template>

<script>
import {data} from '../../shared/data';
import ListingTable from '@/components/shared/ListingTable.vue';

export default {
    name: 'AddAudioActionModal',
    components: { ListingTable },
    props: {
        object: Object,
        isActive: Boolean,
        mediaTypes: Array,
        mediaTypeFilter: {
            type: String,
            default: ''
        },
        mediaTypeFilters: {
            type: Array,
            default: () => []
        }
    },
    data: function() {
        return {
            searchText: '',
            selectedMediaType: '',
            selectedAudioType: 1,
            mediaProperties: [],
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Description",
                    width: "70%",
                    fieldName: "description",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Media Type",
                    width: "20%",
                    fieldName: "mediaType"
                }
            ],
            actionMappings: {
                onLoadData: this.getMediaProperties,
                onSelect: this.saveMediaProperty
            },
        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: "description",
                    value: this.searchText
                });

            if(this.selectedMediaType != '') {
                criteria.push( {
                    dataType: "Boolean",
                    fieldName: "mediaType",
                    value: this.selectedMediaType
                });
            }

            return criteria;
        }
    },
    mounted() {
        document.addEventListener("keydown", (e) => {
            if (e.key == 'Escape')
                this.hideModal();
        });
    },
    methods: {
        showModal: async function() {
            this.mediaProperties = await this.getMediaProperties();
            this.modalActive = true;
            this.componentKey++;
        },
        hideModal: function() {
            this.searchText = '';
            this.selectedMediaType = '';

            this.$emit('hideAddMediaPropertyModal', this.object);
        },
        getMediaProperties: async function() {
            if(this.mediaTypeFilter)
                return await data.getMediaPropertiesByMediaType(this.mediaTypeFilter);
            else if(this.mediaTypeFilters.length > 0) {
                var records = [];
                for(var i = 0; i < this.mediaTypeFilters.length; i++) {
                    records.push(await data.getMediaPropertiesByMediaType(this.mediaTypeFilters[i]));
                }
                return records;
            }
            else
                return await data.getAllMediaProperties(this.searchText, true);
        },
        saveMediaProperty: async function(mp) {
            this.$emit('saveMediaProperty', mp,  this.selectedAudioType);
            this.hideModal();
        },
    }

}
</script>

<style scoped>
    .modal {
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0px;
        left: 0px;
        backdrop-filter: blur(4px);
        padding: 100px 0 0 0;
        display: flex;
        justify-content: center;
        z-index: 10;
    }
    .modalForm {
        position: relative;
        top: 0px;
        left: 0px;
        border: 1px solid lightgray;
        background-color: white;
        width: 800px;
        padding: 20px;
        text-align: left;
        max-height: calc(100vh - 210px);
        overflow-y: auto;
        overflow-x: hidden;
        z-index: 20;
    }

    .searchContainer {
        display:flex; 
        flex-direction: column;
    }
    .modalTitle {
        width: 100%;
        text-align: center;
    }
    #addMediaPropertyModal {
        display: inline-block;
    }
    .cancelButton {
        height: 40px;
        width: 200px;
        border-radius: 5px;
        border-color: rgb(239, 239, 239);
        cursor: pointer;
        font-size: 16px;
        margin-left: 550px;
    }
</style>